import React, { useEffect, useCallback, useState} from 'react';
import SidebarPresets from "components/sidebar/SidebarPresets.js";
import TrackQuickView from 'components/sidebar/TrackQuickView.js';
import QuickSampleChooser from "components/sidebar/QuickSampleChooser.js";
import {setShowArrangementSearcher} from 'actions/index.js';
import {connect} from 'react-redux';
import Modal from 'react-bootstrap/Modal';

const ArrangementSearcher = ({show, sequencerEngine, setShow}) => { 
    if (!show) {
        return [];
    }

    return (
        <Modal dialogClassName="searcher-modal" show={show} onHide={() => setShow(false)}>
          <QuickSampleChooser hide={() => setShow(false)} sequencerEngine={sequencerEngine}/>
          <div className="modal-row">
            <TrackQuickView
              sequencerEngine={sequencerEngine}/>
            <SidebarPresets sequencerEngine={sequencerEngine}/>
          </div>
        </Modal>
    );
}

const mapStateToProps = (state, props) => {
  return {
      show: state.arrangement.showSearcher
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setShow: (x) => dispatch(setShowArrangementSearcher(x))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ArrangementSearcher);
